<section id="mu-unauthorized" class="mu-cant-access">
  <div class="p-grid">
    <h1 class="p-col-12 mu-without-padding" [innerHTML]="'common.unauthorized.title' | translate"></h1>
    <p class="p-col-12 mu-without-padding" [innerHTML]="'common.unauthorized.text' | translate: { stringModule: stringModule }"></p>
    <p-button
      *ngIf="!hideButton"
      class="p-col-12 mu-button mu-without-padding mu-button-secondary"
      (click)="redirect()"
      [label]="'common.unauthorized.btn' | translate"
    ></p-button>
  </div>
</section>
